let html = `<div class="empty">
    <div class="empty__img selector"></div>
    <div class="empty__icon"></div>
    <div class="empty__title">{title}</div>
    <div class="empty__descr">{descr}</div>
</div>`

export default html